import React from "react";
import "./FloatingWhatsApp.css";

const FloatingWhatsApp = () => {
  const phoneNumber = "9341015523";
  const whatsappLink = `https://wa.me/${phoneNumber}?text=Hello%20Geetha`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="floating-whatsapp"
      title="Chat with us on WhatsApp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M12 0C5.373 0 0 5.373 0 12c0 2.251.591 4.38 1.621 6.22L0 24l6.56-1.548C8.77 23.23 10.33 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.84c-1.401 0-2.773-.286-4.031-.826l-.289-.135-2.993.708.72-2.993-.135-.29A9.845 9.845 0 012.16 12c0-5.437 4.403-9.84 9.84-9.84 5.437 0 9.84 4.403 9.84 9.84S17.437 21.84 12 21.84zm5.395-7.317c-.295-.148-1.747-.863-2.019-.963-.272-.1-.47-.148-.668.15-.197.298-.765.963-.938 1.16-.173.198-.346.223-.641.075-.295-.148-1.248-.461-2.378-1.468-.88-.787-1.475-1.757-1.648-2.055-.173-.298-.018-.458.128-.606.134-.133.298-.346.445-.52.148-.173.197-.297.297-.496.1-.199.05-.371-.025-.52-.075-.149-.668-1.611-.915-2.206-.242-.578-.486-.5-.668-.51-.172-.008-.37-.01-.568-.01-.199 0-.52.074-.792.371-.271.298-1.038 1.014-1.038 2.476 0 1.463 1.063 2.875 1.211 3.074.148.198 2.094 3.198 5.073 4.485.709.305 1.262.488 1.694.624.712.226 1.36.194 1.87.117.57-.084 1.758-.718 2.005-1.412.248-.694.248-1.289.173-1.412-.075-.123-.271-.197-.569-.346z" />
      </svg>
    </a>
  );
};

export default FloatingWhatsApp;
